var map = {
	"./alevel-biology.json": 420,
	"./alevel-business.json": 5941,
	"./alevel-chemistry.json": 5355,
	"./alevel-englang.json": 802,
	"./alevel-englit.json": 5808,
	"./alevel-maths.json": 286,
	"./alevel-physics.json": 8230,
	"./alevel-welsh-language.json": 1670,
	"./alevel-welsh-second.json": 4690,
	"./gcse-applied-science-double.json": 6914,
	"./gcse-applied-science-single.json": 1280,
	"./gcse-art.json": 5349,
	"./gcse-biology.json": 6575,
	"./gcse-built-environment.json": 4848,
	"./gcse-business.json": 4364,
	"./gcse-chemistry.json": 9247,
	"./gcse-computer-sci.json": 447,
	"./gcse-design-tech.json": 5835,
	"./gcse-digital-tech.json": 3327,
	"./gcse-drama.json": 399,
	"./gcse-electronics.json": 5339,
	"./gcse-englang.json": 3955,
	"./gcse-englit.json": 5833,
	"./gcse-film.json": 1337,
	"./gcse-food.json": 425,
	"./gcse-french.json": 8541,
	"./gcse-geography.json": 7662,
	"./gcse-geology.json": 1055,
	"./gcse-german.json": 8078,
	"./gcse-health-and-social-care.json": 5540,
	"./gcse-history.json": 7195,
	"./gcse-ict.json": 9084,
	"./gcse-maths.json": 7619,
	"./gcse-media.json": 2604,
	"./gcse-music.json": 8237,
	"./gcse-pe.json": 2275,
	"./gcse-physics.json": 4547,
	"./gcse-religious-studies.json": 5037,
	"./gcse-sociology.json": 8264,
	"./gcse-spanish.json": 1221,
	"./gcse-welsh-language.json": 4148,
	"./gcse-welsh-literature.json": 8740,
	"./gcse-welsh-second.json": 1101,
	"./mfw-gcse-business.json": 4359,
	"./mfw-gcse-computer-sci.json": 9882,
	"./mfw-gcse-core-cymraeg.json": 9601,
	"./mfw-gcse-drama.json": 113,
	"./mfw-gcse-englitlang.json": 1201,
	"./mfw-gcse-food.json": 5753,
	"./mfw-gcse-geography.json": 9488,
	"./mfw-gcse-history.json": 6644,
	"./mfw-gcse-level-2-additional-core-cymraeg.json": 9170,
	"./mfw-gcse-mathematics-and-numeracy.json": 2692,
	"./mfw-gcse-music.json": 2768,
	"./mfw-gcse-religious-studies.json": 4440,
	"./mfw-gcse-welsh-language-and-literature.json": 6973,
	"./test-test.json": 7791
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 752;